import Vue from "vue";
import Router from "vue-router";

import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import Layout from "./views/Layout.vue";

import Overview from "./views/pages/Overview.vue";
import Products from "./views/pages/Products.vue";
import Orders from "./views/pages/Orders.vue";
import SubOrders from "./views/pages/SubOrders.vue";
import SubUsers from "./views/pages/SubUsers.vue";
import Settlements from "./views/pages/Settlements.vue";
import Profile from "./views/pages/Profile.vue";
import Settings from "./views/pages/Settings.vue";
import Withdrawals from "./views/pages/Withdrawals.vue";
import AllOrders from "./views/pages/AllOrders.vue";
import Users from "./views/pages/Users.vue";
import Tutorial from "./views/pages/Tutorial.vue";
Vue.use(Router);

const router = new Router({
  mode: "hash",
  routes: [
    { path: "/login", component: Login },
    { path: "/register", component: Register },
    {
      path: "/",
      component: Layout,
      children: [
        { path: "", redirect: "overview" },
        { path: "overview", component: Overview },
        { path: "products", component: Products },
        { path: "orders", component: Orders },
        { path: "sub-orders", component: SubOrders },
        { path: "sub-users", component: SubUsers },
        { path: "settlements", component: Settlements },
        { path: "profile", component: Profile },
        { path: "settings", component: Settings },
        { path: "withdrawals", component: Withdrawals },
        { path: "all-orders", component: AllOrders },
        { path: "users", component: Users },
        { path: "tutorial", component: Tutorial }
      ]
    },
    { path: "*", redirect: "/" }
  ]
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("access_token");
  const publicPaths = ["/login", "/register"];
  
  // 检查是否已获取用户角色
  const userRole = localStorage.getItem("user_role");
  
  if (!token && !publicPaths.includes(to.path)) return next("/login");
  
  // 管理员专属页面权限检查
  if (to.path === "/settings" || to.path === "/withdrawals" || to.path === "/users"|| to.path === "/all-orders") {
    // 如果本地没有角色信息，需要获取
    if (!userRole) {
      // 跳转到 overview 让 Layout 组件获取用户信息
      return next("/overview");
    }
    // 检查是否是管理员
    if (userRole !== "admin") {
      return next("/overview");
    }
  }
  
  return next();
});

export default router;

